<template>
  <div>
    <div
      class="ind-lhs-info"
      :class="{ full: phones.length <= 0 || addPhoneUser }"
    >
      <ul>
        <li>
          <a href="#" @click.prevent>{{ user.name | clean }}</a>
        </li>
      </ul>

      <div class="message" v-if="showMessage">
        This contact cannot chat because they are not a member of your portal.
      </div>

      <!-- When there are phones -->

      <div
        class="phone-dropdown-design mr-0 float-none"
        v-show="phones.length > 0 && !addPhoneUser"
      >
        <select class="custom-select" @change="phoneChanged">
          <option
            selected
            v-for="(phone, index) in phones"
            :key="index"
            :value="index"
            >{{ phone }}</option
          >
        </select>
      </div>
      <img
        ref="plusIcon"
        class="img-plus"
        :src="plusIcon"
        v-show="
          phones.length < 4 &&
            phones.length > 0 &&
            (user.type === 'person' || user.type === 'other_event') &&
            !addPhoneUser
        "
      />

      <!-- When there are no phones -->
      <div
        key="2"
        class="no-phone-div no-phone-client-div"
        v-if="
          (user.type === 'person' || user.type === 'other_event') &&
            (addPhoneUser || phones.length <= 0)
        "
      >
        <!-- ios input -->
        <input
          v-if="iOS"
          v-model="phone"
          @keydown="setPhone"
          @blur="
            addPhoneLocal(
              user.id,
              user.type === 'person' ? 'CLIENTS' : 'OTHERS'
            )
          "
          type="text"
          pattern="[0-9]*"
          placeholder="Add phone"
          class="add-phone"
          ref="phone"
          autocomplete="off"
          maxlength="12"
        />
        <!-- android input -->
        <input
          v-else
          v-model="phone"
          @keypress.enter="
            addPhoneLocal(
              user.id,
              user.type === 'person' ? 'CLIENTS' : 'OTHERS'
            )
          "
          @keydown="setPhone"
          @blur="hideAddPhoneUser"
          type="text"
          inputmode="numeric"
          placeholder="Add phone"
          class="add-phone"
          ref="phone"
          autocomplete="off"
          maxlength="12"
        />
        <a
          v-if="phone !== ''"
          @click.prevent="hideAddPhoneUser"
          data-v-6b6a9972
          href="#"
          class="search-close-icon"
        >
          <object
            data-v-6b6a9972
            :data="cancelSvg"
            type="image/svg+xml"
          ></object>
        </a>
      </div>

      <!-- Subscriber else -->
      <div
        class="phone-dropdown-design mr-0 float-none alertbox"
        v-else-if="phones.length === 0"
      >
        <i class="text-disabled">
          Phones for
          {{ user.type == "app_user" ? "Users" : "Subscribers" }} must be added
          in the regular PSYBooks app.
        </i>
      </div>
    </div>

    <!-- Chat and call buttons -->
    <div class="ind-rhs-info" v-if="phones.length > 0 && !addPhoneUser">
      <a
        href="#"
        class="buttonstyle"
        :class="{ disabled: !user.user_id }"
        @click.prevent="goToChat(user.user_id)"
      >
        Chat
      </a>
      <a :href="`tel:${phones[selectedIndex]}`" class="buttonstyle">Call</a>
    </div>
    <div class="ind-clear"></div>
  </div>
</template>

<script>
import { addPhoneMixin } from "../../../mixins/addPhoneMixin";
import { mapMutations } from "vuex";

export default {
  mixins: [addPhoneMixin],
  name: "GroupInnerItem",
  props: {
    user: Object // The use object
  },
  data() {
    return {
      selectedIndex: 0, // Selected phone index
      showMessage: false, // Weather to show the not portal user message
      timeout: null, // Timeout
      cancelSvg: require("../../../assets/svg/cancel.svg"), // Cancel button
      plusIcon: require("../../../assets/img/m_plus.png") // Plus icon
    };
  },
  filters: {
    /**
     * Cleaning data
     */
    clean(value) {
      value = value.replace(/&amp;/g, "&").replace(/&amp;/g, "&");
      return value;
    }
  },
  computed: {
    /**
     * All the phones of the user
     */
    phones() {
      return this.user.phone.filter(phone => {
        return phone !== null && phone !== "";
      });
    }
  },
  methods: {
    ...mapMutations("chat", {
      setSelectedUserId: "setSelectedUserId"
    }),
    /**
     * When phone is changed
     */
    phoneChanged(event) {
      this.selectedIndex = event.target.value;
    },
    /**
     * Go to chat
     */
    goToChat(userId) {
      // Step 1: Check if user has userId
      if (!userId) {
        // Step 1: Show the message
        this.showMessage = true;

        // Step 2: Clear timeout if any
        if (this.timeout) {
          clearTimeout(this.timeout);
        }

        // Step 3: Hide message
        this.timeout = setTimeout(() => {
          this.showMessage = false;
          this.timeout = null;
        }, 3000);
      } else {
        // Step 2.1: Set the selectedted user id
        this.setSelectedUserId(userId);

        // Step 2.2: Go to the messages route
        this.$router.push("/messenger");
      }
    }
  },
  mounted() {
    if (this.$refs.plusIcon !== undefined) {
      this.$refs.plusIcon.addEventListener("click", () => {
        this.addPhoneUser = true;
        this.$nextTick(() => {
          this.$refs.phone.focus();
        });
      });
    }
  }
};
</script>

<style scoped>
.message {
  font-size: 12px;
  font-style: italic;
  margin: 10px 0;
}

.no-phone-client-div {
  padding-left: 0px;
  position: relative;
  overflow:hidden;
}

.ind-lhs-info.full {
  width: 100%;
}

.img-plus {
  margin-bottom: 3px;
  cursor: pointer;
}
</style>
